module.exports = __webpack_public_path__ + "static/media/demo-15.70c3b1c9.jpg";